export default __webpack_public_path__ + "static/media/chevron-left-12.ed2a1cd0.svg";